import WaitingListAgent from "../agents/WaitingListAgent";
import {createEffect, createResource, createSignal} from "solid-js";

export function WaitingList (store) {

    // Agent
    const agent = new WaitingListAgent(store);

    // Init
    store.on('@init', (state) => ({
        agents: {
            ...state.agents,
            waitingList: agent,
        },
        loading: {
            ...state.loading,
            myWaitingListEntries: false,
        },
        waitingListResult: null,
        incrementWaitingListResult: null,
        myWaitingListEntries: null,
        myWaitingListEntriesError: false,
        myWaitingListEntriesUserId: null,
    }));

    // Actions d'inscription au créneau.
    store.on('joinWaitingList', async (state, data) => {
        try {
            const result = await agent.joinWaitingList(data);
            store.dispatch("setWaitingListResult", result);
        } catch (err) {
            store.dispatch("setWaitingListResult", { graphQLErrors: true });
        }
    });

    store.on('incrementWaitingList', async (state, data) => {
        try {
            const result = await agent.incrementWaitingList(data);
            store.dispatch("setIncrementWaitingListResult", result);
        } catch (err) {
            store.dispatch("setIncrementWaitingListResult", { graphQLErrors: true });
        }
    });

    store.on('setWaitingListResult', (state, waitingListResult) => ({ waitingListResult }));

    store.on('clearWaitingListResult', () => ({ waitingListResult: null }));

    store.on('setIncrementWaitingListResult', (state, incrementWaitingListResult) => ({ incrementWaitingListResult }));

    store.on('clearIncrementWaitingListResult', () => ({ incrementWaitingListResult: null }));

    // Inscriptions actives du compte. Le fetcher transforme aussi une exception
    // inattendue en Error afin que les erreurs levées et celles renvoyées par
    // Agent.send suivent exactement le même chemin d'état.
    let accountRequestId = 0;
    const [getMyEntries, setGetMyEntries] = createSignal(false);
    const [myEntries] = createResource(
        getMyEntries,
        async (requestId) => {
            try {
                return { requestId, result: await agent.getMyEntries() };
            } catch (err) {
                return { requestId, result: err instanceof Error ? err : new Error(String(err)) };
            }
        }
    );
    createEffect(() => {
        try {
            const response = myEntries();
            if (response !== undefined && response.requestId === accountRequestId) {
                store.dispatch("setMyWaitingListEntries", response.result);
            }
        } catch (err) {
            store.dispatch("setMyWaitingListEntries", err instanceof Error ? err : new Error(String(err)));
        }
    });
    createEffect(() => myEntries.loading && store.dispatch("setMyWaitingListEntriesLoading", true));

    store.on('setMyWaitingListEntriesLoading', (state, myWaitingListEntries) => ({
        loading: { ...state.loading, myWaitingListEntries }
    }));

    store.on('loadMyWaitingListEntries', (state, params) => {
        const userId = params && params.userId;
        if (!userId || (state.myWaitingListEntriesUserId === userId && state.myWaitingListEntries !== null && !state.myWaitingListEntriesError)) {
            return;
        }
        accountRequestId += 1;
        setGetMyEntries(accountRequestId);
        return {
            myWaitingListEntries: null,
            myWaitingListEntriesError: false,
            myWaitingListEntriesUserId: userId,
            loading: { ...state.loading, myWaitingListEntries: true }
        };
    });

    store.on('setMyWaitingListEntries', (state, result) => {
        store.dispatch("setMyWaitingListEntriesLoading", false);
        if (result instanceof Error || !Array.isArray(result)) {
            return { myWaitingListEntries: null, myWaitingListEntriesError: true };
        }
        return { myWaitingListEntries: result, myWaitingListEntriesError: false };
    });

    store.on('clearMyWaitingListEntries', (state) => {
        // Invalide toute réponse encore en vol pour le compte précédent.
        accountRequestId += 1;
        setGetMyEntries(false);
        return {
            myWaitingListEntries: null,
            myWaitingListEntriesError: false,
            myWaitingListEntriesUserId: null,
            loading: { ...state.loading, myWaitingListEntries: false }
        };
    });
}
